export default __webpack_public_path__ + "static/media/WBNB.d8c61230.svg";